import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=22c1001a&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style0 from "./Customers.vue?vue&type=style&index=0&id=22c1001a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1001a",
  null
  
)

export default component.exports